import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { Marquee } from '@sorare/core/src/atoms/container/Marquee';
import { Img } from '@sorare/core/src/atoms/ui/Img';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';
import { sortByTheMiddle } from '@sorare/core/src/lib/arrays';

import {
  EarlyAccessLeaguesQuery,
  EarlyAccessLeaguesQueryVariables,
} from './__generated__/index.graphql';

const EARLY_ACCESS_LEAGUES_QUERY = gql`
  query EarlyAccessLeaguesQuery {
    football {
      leaguesOpenForGameStats(sortType: { direction: ASC, type: PRIORITY }) {
        slug
        id
        displayName
        pictureSecondaryUrl
      }
    }
  }
` as TypedDocumentNode<
  EarlyAccessLeaguesQuery,
  EarlyAccessLeaguesQueryVariables
>;

const Root = styled.div`
  min-height: 80px;
`;

const Image = styled(Img)`
  scroll-snap-align: center;
  min-width: 80px;
`;

export const Leagues = () => {
  const { data } = useQuery(EARLY_ACCESS_LEAGUES_QUERY, {
    fetchPolicy: 'cache-first',
  });
  const leagues = sortByTheMiddle(
    data?.football?.leaguesOpenForGameStats || []
  );

  return (
    <Root>
      {!!leagues.length && (
        <Marquee gap={4}>
          {leagues.map(
            ({ displayName, pictureSecondaryUrl }) =>
              pictureSecondaryUrl && (
                <Image
                  key={pictureSecondaryUrl}
                  src={pictureSecondaryUrl}
                  alt={displayName}
                  width="80"
                  height="80"
                  title={displayName}
                />
              )
          )}
        </Marquee>
      )}
    </Root>
  );
};
